import { NextSeo } from 'next-seo';
import { SHOW_COMMEMORATE } from 'src/constants';

const rejectPage = () => {
  return (
    <>
      {/* -------------------------------- NEXT_SEO -------------------------------- */}
      <NextSeo noindex={false} nofollow={false} />
      <div className='section-reject' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.7)' : '' }}>
        <h3>
          Not Found <span>wrong path</span> :(
        </h3>
      </div>
    </>
  );
};

export default rejectPage;
